import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { YaloService } from '../services/yalo.service';

@Injectable()
export class MultiFaResolver
  implements Resolve<{ [key: string]: boolean | null }>
{
  constructor(private _yalo: YaloService) {}
  resolve(
    route: ActivatedRouteSnapshot
  ):
    | Observable<{ [key: string]: boolean | null }>
    | { [key: string]: boolean | null } {
    const multiFaLocal = this._yalo.multiFactorAuth;

    if (multiFaLocal) {
      return multiFaLocal;
    }
    return this._yalo.getMultiFactorAuth();
  }
}
